export class Stats {
    played;
    streak;
    averageSeconds;
    
    constructor(played, streak, averageSeconds) {
        // streakGames is an array of StatsGame
        // Private field to prevent any changing it from outside, only 
        // appending using the addStatsGame() method is allowed.
        this.played = played
        this.streak = streak
        this.averageSeconds = averageSeconds
    }

    addStatsGame(seconds) {
        console.log("Adding a game of "+seconds+" to the stats")
        if (this.averageSeconds == null || this.played == null || this.played == 0) {
            this.averageSeconds = seconds;
        } else {
            this.averageSeconds = (this.averageSeconds/this.played + seconds)/(this.played+1);
        }
        
        this.played++;
        this.streak++;
    }
}



